define('lq/eventSource',['underscore'], function (_) {
	'use strict';

    // event distribution with strict checking for event name on all operations (listen, trigger, getListeners)
    // can independently add new events to existing ones later on
    // can remove listeners or can subscribe to event only once (not both yet)
    // internal data structures hidden

    // This should be merged with observable, after the above features are added and usage is updated.

	var addEventSource = function (source, eventName) {
		var listeners = [];

		source['withOn' + eventName] = function (handler) {
		    listeners.push(handler);
		    return source;
		};

		var removeListener = function (handler) {
		    var index = listeners.indexOf(handler);
		    if (index >= 0) {
		        listeners.splice(index, 1);
		    }
		}

		source['withOnce' + eventName] = function (handler) {
		    var onceHandler = function () {
		        removeListener(onceHandler);
		        handler.apply(this, arguments);
		    }
		    listeners.push(onceHandler);
		    return source;
		};

		source['withoutOn' + eventName] = function (handler) {
		    removeListener(handler);
			return source;
		};

		source['trigger' + eventName] = function () {
		    var eventArgs = arguments;
		    _.each(listeners.slice(), function (handler) { handler.apply(source, eventArgs); });
		    return source;
		};

		source['get' + eventName + 'Listeners'] = function () {
		    return listeners.slice();
		};

		source['has' + eventName + 'Listeners'] = function () {
		    return listeners.length > 0;
		};
	};
    
	var EventSource = function (eventNameOrNames) {
	    var source = this;

	    if (_.isArray(eventNameOrNames)) {
	        _.each(eventNameOrNames, function (eventName) { addEventSource(source, eventName); });
	    } else {
	        addEventSource(source, eventNameOrNames);
	    }
	};

	return EventSource;
});

